(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-showcase"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    initializeSliders();
  });

  function initializeSliders() {
    const sliders = document.querySelectorAll('.collection-showcase__slider-container');

    sliders.forEach((slider) => {
      let startX = 0;
      let currentX = 0;
      let isDragging = false;
      let currentSlide = 0;
      let autoPlayInterval;
      const totalSlides = parseInt(slider.dataset.totalSlides);
      const sectionId = slider.dataset.sectionId;

      // Initialize the first slide with prev/next
      if (totalSlides > 1) {
        goToSlide(sectionId, 0);
        startAutoPlay(sectionId);
      }

      // Add click events to dots
      const sliderParent = slider.closest('.collection-showcase__product-slider');
      const dots = sliderParent.querySelectorAll('.collection-showcase__slider-dot');
      dots.forEach((dot, index) => {
        dot.addEventListener('click', function () {
          currentSlide = index;
          goToSlide(sectionId, currentSlide);
          resetAutoPlay(sectionId);
        });
      });

      // Add click events to arrows
      const prevArrow = sliderParent.querySelector('.collection-showcase__slider-arrow--prev');
      const nextArrow = sliderParent.querySelector('.collection-showcase__slider-arrow--next');

      if (prevArrow) {
        prevArrow.addEventListener('click', function () {
          currentSlide = (currentSlide - 1 + totalSlides) % totalSlides;
          goToSlide(sectionId, currentSlide);
          resetAutoPlay(sectionId);
        });
      }

      if (nextArrow) {
        nextArrow.addEventListener('click', function () {
          currentSlide = (currentSlide + 1) % totalSlides;
          goToSlide(sectionId, currentSlide);
          resetAutoPlay(sectionId);
        });
      }

      // Touch events
      slider.addEventListener('touchstart', handleTouchStart, { passive: false });
      slider.addEventListener('touchmove', handleTouchMove, { passive: false });
      slider.addEventListener('touchend', handleTouchEnd, { passive: false });

      // Mouse events
      slider.addEventListener('mousedown', handleMouseDown);
      slider.addEventListener('mousemove', handleMouseMove);
      slider.addEventListener('mouseup', handleMouseUp);
      slider.addEventListener('mouseleave', handleMouseUp);

      // Prevent context menu on right click
      slider.addEventListener('contextmenu', (e) => e.preventDefault());

      function handleTouchStart(e) {
        // No prevenir el evento por defecto para permitir clicks en enlaces
        startX = e.touches[0].clientX;
        currentX = startX; // Inicializar currentX
        isDragging = true;
      }

      function handleTouchMove(e) {
        if (!isDragging) return;
        currentX = e.touches[0].clientX;

        // Solo prevenir el scroll si hay movimiento significativo
        const diffX = Math.abs(startX - currentX);
        if (diffX > 10) {
          e.preventDefault();
        }
      }

      function handleTouchEnd(e) {
        if (!isDragging) return;
        isDragging = false;

        const diffX = Math.abs(startX - currentX);
        // Solo manejar como swipe si hay movimiento significativo
        if (diffX > 10) {
          e.preventDefault();
          handleSwipe();
        }
      }

      function handleMouseDown(e) {
        e.preventDefault();
        startX = e.clientX;
        isDragging = true;
        slider.style.cursor = 'grabbing';
      }

      function handleMouseMove(e) {
        if (!isDragging) return;
        e.preventDefault();
        currentX = e.clientX;
      }

      function handleMouseUp(e) {
        if (!isDragging) return;
        isDragging = false;
        slider.style.cursor = 'grab';
        handleSwipe();
      }

      function handleSwipe() {
        const diffX = startX - currentX;
        const threshold = 50; // Minimum distance for swipe

        if (Math.abs(diffX) > threshold) {
          if (diffX > 0) {
            // Swipe left - next slide
            currentSlide = (currentSlide + 1) % totalSlides;
          } else {
            // Swipe right - previous slide
            currentSlide = (currentSlide - 1 + totalSlides) % totalSlides;
          }
          goToSlide(sectionId, currentSlide);
        }
      }
    });
  }

  function goToSlide(sectionId, slideIndex) {
    const slider = document.getElementById(`product-slider-${sectionId}`);
    const slides = slider.querySelectorAll('.collection-showcase__product-slide');
    const dots = slider.querySelectorAll('.collection-showcase__slider-dot');
    const totalSlides = slides.length;

    // Remove all classes from slides and dots
    slides.forEach((slide) => {
      slide.classList.remove('active', 'prev', 'next');
    });
    dots.forEach((dot) => dot.classList.remove('active'));

    // Add active class to current slide and dot
    slides[slideIndex].classList.add('active');
    if (dots[slideIndex]) {
      dots[slideIndex].classList.add('active');
    }

    // Add prev class to previous slide
    const prevIndex = (slideIndex - 1 + totalSlides) % totalSlides;
    slides[prevIndex].classList.add('prev');

    // Add next class to next slide
    const nextIndex = (slideIndex + 1) % totalSlides;
    slides[nextIndex].classList.add('next');
  }

  // Función para iniciar el autoplay
  function startAutoPlay(sectionId) {
    const slider = document.getElementById(`product-slider-${sectionId}`);
    if (!slider) return;

    // Limpiar intervalo existente si hay uno
    if (window.autoPlayIntervals && window.autoPlayIntervals[sectionId]) {
      clearInterval(window.autoPlayIntervals[sectionId]);
    }

    // Crear objeto de intervalos si no existe
    if (!window.autoPlayIntervals) {
      window.autoPlayIntervals = {};
    }

    // Iniciar nuevo intervalo
    window.autoPlayIntervals[sectionId] = setInterval(() => {
      const slides = slider.querySelectorAll('.collection-showcase__product-slide');
      const totalSlides = slides.length;
      const activeSlide = slider.querySelector('.collection-showcase__product-slide.active');

      if (activeSlide) {
        const currentIndex = parseInt(activeSlide.dataset.slide);
        const nextIndex = (currentIndex + 1) % totalSlides;
        goToSlide(sectionId, nextIndex);
      }
    }, 3000); // 3 segundos
  }

  // Función para resetear el autoplay
  function resetAutoPlay(sectionId) {
    if (window.autoPlayIntervals && window.autoPlayIntervals[sectionId]) {
      clearInterval(window.autoPlayIntervals[sectionId]);
    }
    startAutoPlay(sectionId);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 1025px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Funciones para el modal de contacto (globales)
  window.openContactModal = function() {
    const modal = document.getElementById('contactModal');
    if (modal) {
      modal.classList.add('active');
      document.body.style.overflow = 'hidden';
    }
  };

  // Reset url
    function resetUrl() {
      window.history.replaceState({}, document.title, "/")
    }

  window.closeContactModal = function() {
    const modal = document.getElementById('contactModal');
    if (modal) {
      modal.classList.remove('active');
      document.body.style.overflow = '';
    }

    resetUrl();
  };

  // Cerrar modal con Escape
  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape') {
      closeContactModal();
    }
  });

  // Manejar cambio de idioma en el modal de contacto
  document.addEventListener('DOMContentLoaded', function() {
    // Función para manejar el cambio de idioma
    function handleLanguageChange(selector) {
      if (selector && selector.value && selector.form) {
        console.log('Cambio de idioma detectado:', selector.value);
        selector.form.submit();
      }
    }
    
    // Buscar el selector de idioma en el modal de contacto
    const modalLanguageSelector = document.querySelector('#contactModal #LanguageSwitcher select');
    if (modalLanguageSelector) {
      console.log('Selector de idioma encontrado en el modal');
      modalLanguageSelector.addEventListener('change', function() {
        handleLanguageChange(this);
      });
    } else {
      console.log('No se encontró el selector de idioma en el modal');
    }

    // Inicializar selectores de idioma en el modal
    function initializeModalLanguageSelectors() {
      const modal = document.querySelector('#contactModal');
      if (modal) {
        const languageSelectors = modal.querySelectorAll('.language-selector');
        languageSelectors.forEach(function(selector) {
          if (selector.hasAttribute('data-modal-initialized')) return;
          
          selector.setAttribute('data-modal-initialized', 'true');
          
          const button = selector.querySelector('.language-selector__button');
          const dropdown = selector.querySelector('.language-selector__dropdown');
          const hiddenSelect = selector.querySelector('.language-selector__hidden');
          const currentText = selector.querySelector('.language-selector__current');
          
          if (!button || !dropdown || !hiddenSelect || !currentText) return;
          
          // Toggle dropdown al hacer click en el botón
          button.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            dropdown.classList.toggle('active');
            button.setAttribute('aria-expanded', dropdown.classList.contains('active'));
          });
          
          // Manejar click en opciones
          const options = selector.querySelectorAll('.language-selector__option');
          options.forEach(option => {
            option.addEventListener('click', function(e) {
              e.preventDefault();
              e.stopPropagation();
              
              const value = this.getAttribute('data-value');
              const text = this.textContent;
              
              currentText.textContent = text;
              hiddenSelect.value = value;
              
              dropdown.classList.remove('active');
              button.setAttribute('aria-expanded', 'false');
              
              if (hiddenSelect.form) {
                console.log('Enviando formulario de cambio de idioma desde modal:', value);
                hiddenSelect.form.submit();
              }
            });
          });
          
          console.log('Selector de idioma inicializado en modal');
        });
      }
    }
    
    // Inicializar selectores del modal
    initializeModalLanguageSelectors();

    // Check if form newsletter success
    const currentUrl = location.href;
    if(currentUrl.includes("customer_posted=true#NewsletterFormModal")) {
      const buttonOpen = document.querySelector('[onclick="openContactModal()"]');
      if(buttonOpen) buttonOpen.click();
    }
  });



  } catch(e) { console.error(e); }
})();
})();
